// ContactDto.ts
export interface ContactDto {
    name: string;
    email: string;
    phone?: string;
    subject: string;
    message: string;
}

// Anti-bot honeypot: the form sends a hidden field under this key, which a
// person never fills in. A non-empty value means a bot - the controller then
// answers success without sending anything (no captcha needed).
export const CONTACT_HONEYPOT_FIELD = 'honeypot';
